import e from"./SearchBox.vue_vue&type=script&lang.js";import{render as r}from"./SearchBox.vue_vue&type=template&id=5c16d9af&lang.js";e.render=r;export default e;
//# sourceMappingURL=SearchBox.vue.js.map
